const vlmInstructons = {
  instruction: "Instruction",
  AddNewInstruction: "Add new instruction",
  location: "Location",
  rule: "Rule",
  documentType: "Document Type",
  tags: "Tags",
  actions: "Actions",
  cancel: "Cancel",
  save: "Save",
  fieldName: "Field Name",
  tableName: "Table Name",
  IgnoreField: "Ignore Field",
  InstructionLocation: "Instruction Location",
  InstructionRule: "Instruction Rule",
  InstructionDocumentType: "Instruction Document Type",
  InstructionTags: "Instruction Tags",
  AddInstruction: "Add Instruction",
  NoInstructionsFound: "No instructions found",
  Loading: "Loading",
  instructionUpdatedSuccessfully: "Instruction updated successfully",
  instructionCreatedSuccessfully: "Instruction created successfully",
  fieldIgnoredSuccessfully: "Field ignored successfully",
  create: "Create",
  edit: "Edit",
  noInstructions: "No instructions found",
  ignoreField: "Ignore Field",
  instruction_already_defined:
    "Instruction already defined, please delete all instructions",
  instructionDeletedSuccessfully: "Instruction deleted successfully",
  location_is_required: "Location is required",
  rule_is_required: "Rule is required",
  tags_are_required: "Tags are required",
  instruction_already_ignored: "Instruction already ignored",
  ignored: "Ignored",
  ignored_status: "Ignored Status",
  location_hint:
    "A location tells the model where in the document to look for the field's value.",
  rule_hint:
    "A rule is field-level guidance you write for one specific field. It tells the model how to find, interpret, and return that field's value.",
  general: "General",
  tagWise: "Tag Wise",
  extraction_rules: "Extraction Rules",
  add_new_rule: "Add New Rule",
  field_name: "Field name",
  scope: "When will the Extraction rule be applied?",
  field_extraction_status: "Field Extraction Status",
  all_documents: "All Documents",
  preview_rules_by_scope: "Preview rules by Scope",
  preview_rules_by_tag: "Preview rules by tag",
  extract: "Extract",
  exclude: "Exclude",
  delete: "Delete",
  no_rules_found: "No extraction rules found",
  add_new_rule_subtitle:
    "Define how the AI should locate and extract a specific field",
  all_documents_desc: "Apply to all documents",
  document_type: "Document Type",
  document_type_desc: "Apply to specified type of document",
  custom_tag: "Custom Tag",
  custom_tag_desc: "Apply to document with specified keyword",
  add: "Add",
  field_name_required: "Field name is required",
  rule_required: "Visual description is required",
  document_class_required: "Document type is required",
  tags_required: "At least one tag is required",
  instruction_created_successfully: "Extraction rule created successfully",
  instruction_updated_successfully: "Extraction rule updated successfully",
  instruction_deleted_successfully: "Extraction rule deleted successfully",
  something_went_wrong: "Something went wrong",
  select_document_type: "Select document type",
  tags_placeholder: "Select existing tags or create new tags by typing tag name and pressing enter.",
  warningTemplate: {
    title: "Active Extraction rules against each Field",
    description:
      "Fields with no extraction rules created for specified tag will be extracted via Global & Document type wise rules",
    descriptionDoc:
      "Fields with no extraction rules created for specified document type will be extracted via Global rules",
  },
  instruction_delete_title: `Are you sure you want to delete this instruction?`,
  instruction_delete_description: `Deleting the item will remove it from your instruction?`,
  instruciton_ignore_title: "Are you sure you want to Ignore Field",
  instrunction_ignore_description:
    "Ignoring this field will delete all of its associated extraction rules created and field will be ignored for all documents",
  update: "Update",
  what_field_shold_extract: "What field should be extracted?",
  docType: "DocType",
  tag: "Tag",
  emptyState: {
    titleTag: "Choose a tag to see which extraction rules apply to each field",
    descriptionTag:
      "If a field has no rule set for this tag, you'll also see inherited rules from the document type or global level.",
    titleDoc:
      "Choose a Document Type to see which extraction rules apply to each field",
    descriptionDoc:
      "If a field has no rule set for this document type, you'll also see inherited rules from the global level.",
  },
  select_tag: "Select Tag",
  scope_column: "Scope",
  edit_extraction_rule: "Edit Extraction Rule",
  add_new_extraction_rule: "Add New Extraction Rule",
  extraction_rule_dialog_subtitle:
    "Tell Dost which field to look for, where the rule applies, and how to recognise it.",
  what_should_dost_do: "What should Dost do with it?",
  action_extract: "Extract",
  action_extract_desc: "Read the value from the document",
  action_ignore: "Ignore",
  action_ignore_desc: "Skip it everywhere during extraction",
  where_does_rule_apply: "Where does this rule apply?",
  scope_all_documents: "All Documents",
  scope_all_documents_desc: "Every document processed by Dost",
  scope_document_type: "Document Type",
  scope_document_type_desc: "e.g. Invoice, Purchase Order, etc",
  scope_tagged_documents: "Tagged Documents",
  scope_tagged_documents_desc: "tags like Google, Madrid, VendorID-0101, etc",
  what_does_it_look_like: "What does it look like?",
  upload_image: "Upload Image",
  write_manually: "Write Manually",
  upload_hint:
    "Dost describes what it sees and writes the visual description for you",
  generating_visual_description:
    "Generating visual description with Dost AI...",
  visual_description_generated:
    "Visual description generated successfully from image",
  visual_description: "Visual Description",
  visual_description_placeholder_upload: "Visual description",
  visual_description_placeholder_manual:
    'Describe where the value sits and how to recognise it e.g. "Bold Alphanumeric code of 18pt size next to Delivery note label on top right"',
  visual_description_hint_upload:
    "Descriptions written in English perform better and you can edit it to be more precise",
  visual_description_hint_manual: "Write description in English or",
  use_sample_prompt: "Use Sample Prompt",
  visual_description_max_length:
    "Visual description cannot exceed {{max}} characters",
  surpress_info:
    "This instruction won't execute it is suppressed, because its a part of {{scope}} Scope",
};

export default vlmInstructons;
